// removed by extract-text-webpack-plugin
module.exports = {"title-content":"addPackageComponent__title-content--3UXNC","actions-container":"addPackageComponent__actions-container--z7sK4"};


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/applications/styles/addPackageComponent.scss
// module id = angL
// module chunks = 23